<template>
  <div class="otherSiteList">
    <lida-table :propscolumns="columns" :data="items"></lida-table>
  </div>
</template>
<script>
import UploadImage from "@/views/acount/components/UploadImage.vue";
import { mapGetters } from 'vuex';
export default {
  name: "otherSiteList",
  data () {
    return {
      date: new Date().getTime(),
      items: [],
      imageFile: [],
      columns: {
        ifname: {
          title: '站点名稱',
          key: 'ifname',
          align: 'center'
        },
        subordinate: {
          title: '圖片 / 內容',
          key: 'subordinate',
          align: 'center',
          render: (h, params) => {
            const index = this.items.map(it => it.id).indexOf(params.row.id)
            const Clickinputstate = () => this.$set(this.items[index], 'inputstate', !params.row.inputstate)
            if (params.row.cls == 1) {
              if (!params.row.inputstate) return h('span', params.row.subordinate)
              const Input = h('Input', {
                props: {
                  value: params.row.inputDefault
                },
                style: {
                  width: '150px'
                },
                on: {
                  input: event => this.$set(this.items[index], 'inputDefault', event)
                }
              })
              return Input
            } else {
              const _img = h('img', {
                style: {
                  maxWidth: '100%',
                  display: 'block',
                  margin: 'auto',
                  maxHeight: '100%',
                  padding: '0 4px',
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  right: '0',
                  bottom: '0'
                },
                domProps: {
                  src: `${process.env.VUE_APP_IMAGE_URL}/img/${params.row.subordinate}.jpge?${this.date}`
                }
              })
              const imgContent = h('div', {
                style: {
                  width: '100px',
                  height: '100px',
                  margin: '4px',
                  border: '1px solid #e2e2e2',
                  borderRadius: '4px',
                  position: 'relative'
                }
              }, [_img])
              const update = h(UploadImage, {
                props: {
                  title: params.row.ifname,
                  imgname: params.row.subordinate,
                  _class: params.row.id
                },
                on: {
                  pushImageList: ({ file, _class }) => {
                    this.imageFile.push({ file: file, listid: _class, cls: 2 })
                  },
                  removeImageList: (_class) => {
                    this.imageFile = this.imageFile.filter(it => it._class === _class)
                  }
                }
              })
              return h('span', {
                class: { '_alignmiddle': true }
              }, [
                imgContent,
                params.row.inputstate ? update : null
              ])
            }
          }
        },
        cls: {
          title: '顯示',
          key: 'cls',
          align: 'center',
          render: (h, params) => {
            return h('Tag', params.row.cls == 1 ? '文字' : '圖片')
          }
        },
        inputstate: {
          title: '操作',
          key: 'inputstate',
          align: 'center',
          render: (h, params) => {
            const index = this.items.map(it => it.id).indexOf(params.row.id)
            const Clickinputstate = () => this.$set(this.items[index], 'inputstate', !params.row.inputstate)
            const modifyButton = h('Button', {
              props: { type: 'info' },
              on: {
                click: () => Clickinputstate()
              }
            }, '修改')
            const SeveButton = h('Button', {
              props: {
                type: 'error'
              },
              on: {
                click: () => {
                  this.modfiyOtherlist(this.items[index], params.row.cls)
                  Clickinputstate()
                }
              }
            }, '儲存')
            return params.row.inputstate ? SeveButton : modifyButton
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  created () {
    this.getotherlist()
  },
  methods: {
    async getotherlist () {
      try {
        const res = await this.$axios.setting.getotherlist()
        if ('status' in res && res.status === 0) return
        this.items = res.map(it => {
          it.inputstate = false
          it.inputDefault = it.subordinate
          return it
        })
      } catch (error) {
        console.error(error)
      }
    },
    async modfiyOtherlist (value, cls) {
      if (cls == 1 && value.inputDefault == value.subordinate) return this.$Message.error('无修改')
      const obj = {
        loid: this.getmember.pid,
        updlist: [{
          listid: value.id,
          newvalue: value.inputDefault,
          cls: Number(value.cls)
        }]
      }
      let formData = new FormData();
      formData.append('objdata', JSON.stringify(obj));
      this.imageFile.forEach(it => {
        formData.append('gclogo', it.file);
      })
      try {
        const res = await this.$axios.setting.modifyotherlist(formData)
        if (res.status === 0) return
        if ((value.cls == 2 && res.img.status === 1) || (value.cls == 1 && res.data.status === 1)) {
          this.getotherlist()
          this.date = new Date().getTime()
          this.$Message.success('修改成功')
        }
      } catch (error) {
        console.log(error);
        this.$Message.error('修改失敗')
      }

    }
  }
}
</script>
<style lang="scss">
.otherSiteList {
  .lida-table {
    .ivu-table-small td {
      height: 110px;
    }
  }
}
</style>